// extracted by mini-css-extract-plugin
module.exports = {"panel":"ReviewAiClipCandidateModal_panel__CuSKH"};